import React from "react";

export const ErrorMessage = ({ message }) => {
  return (
    <p className="invalid-feedback d-block text-capitalize-first">{(message || "")}</p>
  );
};

export const showContentLoader = (props) => {
  return (
    <div className={`loader ${(props.className || "")}`} />
  );
};
